import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNotification } from '../../contexts/NotificationContext';
import historiaService from '../../services/historiaService';
import { generateHistoriaClinicaHTML } from '../../utils/printUtils';

const PrintHistoria = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [historia, setHistoria] = useState(null);

  // Cargar la historia clínica
  useEffect(() => {
    const fetchHistoria = async () => {
      setLoading(true);
      try {
        const response = await historiaService.getHistoria(id);
        setHistoria(response.data);
      } catch (error) {
        console.error('Error fetching historia:', error);
        showNotification('Error al cargar la historia clínica', 'error');
        navigate(`/historias/${id}`);
      } finally {
        setLoading(false);
      }
    };

    fetchHistoria();
  }, [id, navigate, showNotification]);

  // Imprimir automáticamente cuando los datos estén cargados
  useEffect(() => {
    if (historia) {
      // Dar un poco de tiempo para que se renderice la página
      const timer = setTimeout(() => {
        window.print();
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [historia]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!historia) {
    return (
      <Box p={3} textAlign="center">
        <Typography variant="h6" color="error" gutterBottom>
          Error al cargar la historia clínica
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/historias/${id}`)}
        >
          Volver
        </Button>
      </Box>
    );
  }

  // Usar el HTML generado por la utilidad
  const createMarkup = () => {
    return { __html: generateHistoriaClinicaHTML(historia) };
  };

  return (
    <Box>
      <div dangerouslySetInnerHTML={createMarkup()} />
    </Box>
  );
};

export default PrintHistoria;